<template>
  <div>
    <div class="font-inter border border-gray-200 sm:rounded-lg">
      <div class="flex items-center gap-2 px-6 py-4">
        <span class="text-lg capitalize text-primary">{{ singularEntity }}s</span>
        <div
          class="default-badge font-inter w-fit select-none rounded-full bg-main-tertiary/10 px-3 py-1 text-center text-main-primary"
        >
          <span class="block text-xs">0 {{ singularEntity }}s</span>
        </div>
      </div>

      <div class="relative">
        <table class="w-full text-left text-sm text-gray-500">
          <tbody>
            <tr>
              <td class="flex h-72 items-center justify-center">
                <div class="text-center">
                  <span class="mb-1 block text-base font-medium text-primary">
                    <span class="capitalize">{{ singularEntity }}s</span> table
                    is empty
                  </span>
                  <p class="mx-auto mb-4 w-3/5 text-tertiary">
                    There are no records to display for now. Add new
                    {{ singularEntity }}s to view the results on the table.
                  </p>
                  <button
                    type="button"
                    class="font-inter mx-auto mb-5 flex transform items-center justify-center gap-2 rounded bg-main-primary px-4 py-1.5 text-sm text-white shadow-sm hover:-translate-y-0.5 hover:bg-main-secondary active:bg-main-primary"
                    @click="$emit('addEntity')"
                  >
                    <PlusIcon />
                    <span class="capitalize">create {{ singularEntity }}</span>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyStateTable',

  props: {
    entity: {
      type: String,
      required: true,
    },
  },

  emits: ['addEntity'],

  computed: {
    singularEntity() {
      return this.entity.charAt(this.entity.length - 1) === 's'
        ? this.entity.substring(0, this.entity.length - 1)
        : this.entity
    },
  },
}
</script>
